function Quote() {
    return (
        <section className="container-fluid" id="Quote">
            <div className="container quote-div">
                <h1>Quote Of The Day</h1>
                <article>
                    <p>“The more that you read, the more things you will know. The more that you learn, the more places you’ll go.”</p>
                    <h5>Dr. Seuss</h5>
                </article>
            </div>

        </section>
    );
}
export default Quote;